import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

type Genero = 'nino' | 'nina';

interface GenderContextValue {
  genero: Genero;
  setGenero: (g: Genero) => void;
}

const GenderContext = createContext<GenderContextValue>({
  genero: 'nina',
  setGenero: () => {},
});

export function GenderProvider({ children }: { children: ReactNode }) {
  const [genero, setGenero] = useState<Genero>('nina');
  return (
    <GenderContext.Provider value={{ genero, setGenero }}>
      {children}
    </GenderContext.Provider>
  );
}

export function useGender() {
  return useContext(GenderContext);
}
